// Auto-generated from gen_ce_info_and_maps.ts
// DO NOT EDIT THIS FILE DIRECTLY

import { CeInfoType } from '../types/ce';

const data: CeInfoType = {
  'CalamityBound': {
    'directorId': '32F',
    'name': {
      'cn': '挣脱封印的大妖异——回廊恶魔',
      'de': 'Das versiegelte Unheil',
      'en': 'Calamity Bound',
      'fr': 'Défi : Cloître à perpétuité',
      'ja': '封印大妖「クロイスターデーモン」',
      'ko': '봉인된 대요마 \'회랑 악마\'',
    },
  },
  'CompanyOfStone': {
    'directorId': '343',
    'name': {
      'cn': '石制骑士团',
      'de': 'Die steinerne Staffel',
      'en': 'Company of Stone',
      'fr': 'L\'armée des argileux',
      'ja': '石造りの守護騎士たち',
      'ko': '돌로 만들어진 수호 기사들',
    },
  },
  'CrawlingDeath': {
    'directorId': '330',
    'name': {
      'cn': '潜影撕裂者——死亡爪',
      'de': 'Das messerscharfe Schicksal',
      'en': 'Crawling Death',
      'fr': 'Défi : face de griffes',
      'ja': '忍び寄る爪「デスクロー」',
      'ko': '은밀히 다가오는 손톱 \'죽음손아귀\'',
    },
  },
  'CursedConcern': {
    'directorId': '32B',
    'name': {
      'cn': '贩卖诅咒的商贩——金钱龟',
      'de': 'Das Feilschen ums Verfluchte',
      'en': 'Cursed Concern',
      'fr': 'Défi : être aux pièces',
      'ja': '呪いの商亀「コイントートス」',
      'ko': '저주를 파는 거북 \'동전거북\'',
    },
  },
  'EternalWatch': {
    'directorId': '329',
    'name': {
      'cn': '城塞守卫——复原狮像',
      'de': 'Ausgebessert und verbessert',
      'en': 'Eternal Watch',
      'fr': 'Défi : comme un lion nouveau',
      'ja': '復元された獅子像「リペアドライオン」',
      'ko': '오래된 사자상 \'복원된 사자\'',
    },
  },
  'FlameOfDusk': {
    'directorId': '32A',
    'name': {
      'cn': '昏暗妖魂——鬼火苗',
      'de': 'Das finsterste Feuer',
      'en': 'Flame of Dusk',
      'fr': 'Défi : les ailes de pierre',
      'ja': '昏き篝火「ヒンキーパンク」',
      'ko': '어둑한 화톳불 \'힝키펑크\'',
    },
  },
  'FromTimesBygone': {
    'directorId': '323',
    'name': {
      'cn': '双极的造物——神秘土偶',
      'de': 'Von uralten Magien',
      'en': 'From Times Bygone',
      'fr': 'Défi : idole surprise',
      'ja': '神秘の偶像「ミシカルアイドル」',
      'ko': '수수께끼에 싸인 토우 \'신비로운 우상\'',
    },
  },
  'NoiseComplaint': {
    'directorId': '327',
    'name': {
      'cn': '厌鸟巨兽——进化加鲁拉',
      'de': 'Keine Gnade dem Gefieder',
      'en': 'Noise Complaint',
      'fr': 'Défi : mammouth fâché',
      'ja': '鳥嫌いの巨獣「ネオガルラ」',
      'ko': '새를 싫어하는 거대 짐승 \'네오 가루라\'',
    },
  },
  'OnTheHunt': {
    'directorId': '338',
    'name': {
      'cn': '双足狮人——跃立狮',
      'de': 'Gefürchtetes Gebrüll',
      'en': 'On the Hunt',
      'fr': 'Défi : à rugir debout',
      'ja': '二足の獅子「ランパントライオン」',
      'ko': '두 발로 선 사자 \'직립 사자\'',
    },
  },
  'ScourgeOfTheMind': {
    'directorId': '320',
    'name': {
      'cn': '脑髓爱好者——夺心魔',
      'de': 'Die Geißel des Geistes',
      'en': 'Scourge of the Mind',
      'fr': 'Défi : l\'encéphalophage',
      'ja': '脳髄愛好家「マインドフレイア」',
      'ko': '뇌수 애호가 \'정신탈취자\'',
    },
  },
  'SharkAttack': {
    'directorId': '32E',
    'name': {
      'cn': '传说中的鲨鱼——尼姆瓣齿鲨',
      'de': 'Jäger aus alten Legenden',
      'en': 'Shark Attack',
      'fr': 'Défi : homo selachus',
      'ja': '伝説の鮫「ニーム・ペタロドゥス」',
      'ko': '전설의 상어 \'니므 페탈로두스\'',
    },
  },
  'TheBlackRegiment': {
    'directorId': '322',
    'name': {
      'cn': '黑色连队',
      'de': 'Das schwarze Regiment',
      'en': 'The Black Regiment',
      'fr': 'Plumes d\'encre',
      'ja': '黒の連隊',
      'ko': '검은 연대',
    },
  },
  'TheForkedTowerBlood': {
    'directorId': '33B',
    'name': {
      'cn': '两歧塔 力之塔',
      'de': 'Der Turm des Blutes',
      'en': 'The Forked Tower: Blood',
      'fr': 'Tour fourchue de la Force',
      'ja': 'フォークタワー：力の塔',
      'ko': '포크 타워: 힘의 탑',
    },
  },
  'TheUnbridled': {
    'directorId': '348',
    'name': {
      'cn': '愤怒的人造人——新月狂战士',
      'de': 'Zorn auf zwei Beinen',
      'en': 'The Unbridled',
      'fr': 'Défi : le rageux',
      'ja': '怒れる人造人間「クレセント・バーサーカー」',
      'ko': '분노한 인조인간 \'초승달 광전사\'',
    },
  },
  'TrialByClaw': {
    'directorId': '349',
    'name': {
      'cn': '拟造使魔——水晶龙',
      'de': 'Tödliche Schönheit',
      'en': 'Trial by Claw',
      'fr': 'Défi : écailles de cristal',
      'ja': '模造されしもの「水晶竜」',
      'ko': '모조된 존재 \'수정룡\'',
    },
  },
  'WithExtremePrejudice': {
    'directorId': '339',
    'name': {
      'cn': '防卫指令',
      'de': 'Mit absoluter Sicherheit',
      'en': 'With Extreme Prejudice',
      'fr': 'Cordon de sécurité',
      'ja': 'セキュリティ・コマンドー',
      'ko': '보안 명령',
    },
  },
} as const;

export default data;
